export default __webpack_public_path__ + "static/media/icon3.b2d76076.svg";